import { Injectable } from '@angular/core';
import { DocumentIdNumRequestDTO } from '../model/requests-model';

@Injectable({
  providedIn: 'root',
})
export class UpdateDocumentationStore {
  private documentIdNumRequestHistory: DocumentIdNumRequestDTO[] = [];

  addDocumentIdNumRequestHistory(documentIdNumRequest: DocumentIdNumRequestDTO) {
    this.documentIdNumRequestHistory.push(documentIdNumRequest);
  }

  getDocumentIdNumRequestHistory(): DocumentIdNumRequestDTO[] {
    return this.documentIdNumRequestHistory;
  }

  getDocumentIdNumRequestHistoryByNumRequest(numRequest: string): DocumentIdNumRequestDTO {
    return this.documentIdNumRequestHistory.find(
      (documentIdNumRequest) => documentIdNumRequest.numOperation === numRequest
    );
  }

  clearDocumentIdNumRequestHistory() {
    this.documentIdNumRequestHistory = [];
  }
}
